import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { generateDeviceFingerprint } from '../utils/deviceFingerprint';
import { API_CONFIG } from '../../config/api';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isValidating, setIsValidating] = useState(true);
    const [isValid, setIsValid] = useState(false);
    const token = localStorage.getItem('novaqToken');
    const deviceId = localStorage.getItem('deviceId');
    
    console.log('🔒 ProtectedRoute - Token check:', token ? 'Token exists' : 'No token');
    console.log('🔒 ProtectedRoute - Device ID:', deviceId);
    console.log('🔒 ProtectedRoute - Current URL:', window.location.href);
    
    useEffect(() => {
        const validateToken = async () => {
            // Double check token from localStorage
            const currentToken = localStorage.getItem('novaqToken');
            console.log('🔒 ProtectedRoute - Current token check:', currentToken ? 'Token exists' : 'No token');
            
            if (!currentToken) {
                console.log('🔒 No token found, redirecting to login');
                setIsValidating(false);
                setIsValid(false);
                return;
            }
            
            // Check if device ID matches
            const currentDeviceId = generateDeviceFingerprint();
            if (deviceId !== currentDeviceId) {
                console.log('🔒 Device mismatch, clearing tokens and redirecting');
                localStorage.clear();
                setIsValidating(false);
                setIsValid(false);
                return;
            }
            
            // Simple token validation - just check if token and deviceId exist
            console.log('🔒 Token and device ID are valid, allowing access');
            setIsValidating(false);
            setIsValid(true);
        };
        
        validateToken();
    }, [token, deviceId]);
    
    if (isValidating) {
        return <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                <p className="mt-4 text-gray-600">Шалгаж байна...</p>
            </div>
        </div>;
    }
    
    if (!isValid) {
        return <Navigate to="/" replace />;
    }
    
    return <>{children}</>;
};

export default ProtectedRoute; 